import { createAction } from "redux-act";

export const RESET_PASSWORD = "RESET_PASSWORD_DATA";
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";

export const resetPassword = createAction(RESET_PASSWORD);
export const resetPasswordFailed = createAction(RESET_PASSWORD_FAILED);
export const resetPasswordSuccess = createAction(RESET_PASSWORD_SUCCESS);
